<template>
  <section class="knowledge-page">
    <header class="knowledge-hero">
      <div class="hero-content">
        <p>知识管理系统</p>
        <h2>让组织知识<br>沉淀为持续创造力</h2>
        <p class="hero-description">面向组织知识资产建设，连接知识采集、整理、检索、共享与复用，构建统一、高效、可持续演进的知识管理体系。</p>
        <div class="hero-tags">
          <span>知识沉淀</span>
          <span>全文检索</span>
          <span>协同共享</span>
        </div>
      </div>
      <div class="hero-panel" aria-hidden="true">
        <div class="panel-title"><span></span>知识工作台</div>
        <div class="panel-search">搜索知识、文档和业务经验</div>
        <div class="panel-line panel-line-wide"></div>
        <div class="panel-results">
          <div><strong>制度与规范</strong><span>知识库 · 128 条</span></div>
          <div><strong>业务经验沉淀</strong><span>知识库 · 96 条</span></div>
        </div>
        <div class="panel-result"><span>知识复用率</span><strong>86%</strong></div>
      </div>
    </header>

    <section class="overview-section">
      <div class="section-heading">
        <h3>一套系统，连接知识全生命周期</h3>
        <p>把分散在文档、业务和人员经验中的知识统一管理，让知识找得到、看得懂、用得上。</p>
      </div>
      <div class="knowledge-features">
        <article v-for="feature in features" :key="feature.title" class="knowledge-feature">
          <h4>{{ feature.title }}</h4>
          <p>{{ feature.description }}</p>
          <ul>
            <li v-for="item in feature.points" :key="item">{{ item }}</li>
          </ul>
        </article>
      </div>
    </section>

    <section class="process-section">
      <div class="section-heading process-heading">
        <h3>让知识从沉淀走向应用</h3>
      </div>
      <div class="process-list">
        <div v-for="step in process" :key="step.title" class="process-step">
          <div>
            <h4>{{ step.title }}</h4>
            <p>{{ step.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="value-section">
      <div class="value-copy">
        <h3>让组织经验真正流动起来</h3>
        <p>通过统一的知识入口和清晰的权限体系，减少重复查找与重复建设，持续释放知识资产价值。</p>
      </div>
      <div class="value-list">
        <div v-for="value in values" :key="value.title" class="value-item">
          <strong>{{ value.title }}</strong>
          <span>{{ value.description }}</span>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'KnowledgeManagement',
  data () {
    return {
      features: [
        { title: '知识统一沉淀', description: '将制度、文档、案例和业务经验集中归档，形成可持续积累的组织知识库。', points: ['支持多类型文档与知识分类', '建立统一的知识目录和标签体系'] },
        { title: '智能全文检索', description: '快速定位需要的知识内容，降低信息分散带来的查找成本。', points: ['支持关键词、分类和标签检索', '全文搜索并高亮展示相关内容'] },
        { title: '权限协同共享', description: '在安全可控的前提下促进知识流转，让团队经验能够被更多业务复用。', points: ['按组织、角色和知识范围授权', '支持知识发布、审核和版本管理'] },
        { title: '知识关联复用', description: '建立知识之间的关系，帮助用户发现关联内容并调用已有业务成果。', points: ['构建知识关联与主题聚合', '提供文档调用接口和复用统计'] }
      ],
      process: [
        { title: '采集整理', description: '汇聚组织内部文档、制度和业务经验，按照统一标准完成分类与整理。' },
        { title: '审核发布', description: '通过权限控制和审核流程，确保知识内容准确、规范并可持续维护。' },
        { title: '检索复用', description: '面向业务场景快速检索相关知识，支持在线查看、分享和接口调用。' }
      ],
      values: [
        { title: '易沉淀', description: '减少经验流失，形成组织资产' },
        { title: '快检索', description: '统一知识入口，提升获取效率' },
        { title: '高复用', description: '连接业务场景，放大知识价值' }
      ]
    }
  }
}
</script>

<style scoped>
.knowledge-page { background: #fff; color: #20344e; }
.knowledge-hero { display: flex; min-height: 430px; align-items: center; justify-content: space-between; gap: 70px; padding: 76px max(24px, calc((100vw - 1200px) / 2)); background: #f4f8ff; }
.hero-content { max-width: 620px; }
.hero-content > p:first-child { margin: 0 0 15px; color: #1f5dea; font-size: 13px; font-weight: 600; }
.hero-content h2 { margin: 0; color: #20344e; font-size: 40px; font-weight: 600; line-height: 1.45; }
.hero-description { max-width: 550px; margin: 22px 0 0; color: #6c7d91; font-size: 16px; line-height: 1.9; }
.hero-tags { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 28px; }
.hero-tags span { padding: 8px 16px; border: 1px solid #d7e4fb; border-radius: 3px; background: #fff; color: #3866a9; font-size: 13px; }
.hero-panel { width: 320px; padding: 28px; border: 1px solid #dce8f8; border-radius: 6px; background: #fff; box-shadow: 0 16px 35px rgba(49, 91, 147, .1); }
.panel-title { display: flex; align-items: center; gap: 9px; color: #38506d; font-size: 15px; font-weight: 600; }
.panel-title span { width: 8px; height: 8px; border-radius: 50%; background: #2e73e8; }
.panel-search { margin-top: 27px; padding: 11px 13px; border: 1px solid #dce8f8; color: #9aaabd; font-size: 12px; }
.panel-line { width: 76%; height: 8px; margin-top: 20px; border-radius: 2px; background: #edf2f9; }
.panel-line-wide { width: 100%; margin-top: 18px; background: #dce8f8; }
.panel-results { margin-top: 22px; }
.panel-results div { display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid #eef2f8; }
.panel-results strong { color: #38506d; font-size: 12px; font-weight: 500; }
.panel-results span { color: #92a1b2; font-size: 11px; }
.panel-result { display: flex; justify-content: space-between; margin-top: 18px; color: #75869a; font-size: 13px; }
.panel-result strong { color: #2e73e8; font-weight: 600; }
.overview-section, .process-section { padding: 78px max(24px, calc((100vw - 1200px) / 2)); }
.section-heading { max-width: 650px; margin: 0 auto 46px; text-align: center; }
.section-heading h3, .value-copy h3 { margin: 0; color: #20344e; font-size: 30px; font-weight: 600; line-height: 1.45; }
.section-heading > p:last-child { margin: 16px 0 0; color: #8290a1; font-size: 15px; line-height: 1.8; }
.knowledge-features { display: grid; grid-template-columns: repeat(4, 1fr); gap: 18px; }
.knowledge-feature { min-height: 290px; padding: 28px 24px; border: 1px solid #e4ebf4; border-radius: 4px; background: #fff; transition: transform .2s, box-shadow .2s; }
.knowledge-feature:hover { transform: translateY(-4px); box-shadow: 0 12px 25px rgba(43, 82, 132, .1); }
.knowledge-feature h4 { margin: 0 0 12px; color: #263e5d; font-size: 19px; font-weight: 600; }
.knowledge-feature > p { min-height: 51px; margin: 0; color: #76869a; font-size: 13px; line-height: 1.7; }
.knowledge-feature ul { margin: 17px 0 0; padding: 14px 0 0 17px; border-top: 1px solid #edf1f6; color: #59718f; }
.knowledge-feature li { margin-bottom: 7px; font-size: 13px; line-height: 1.5; }
.process-section { background: #f7f9fc; }
.process-heading { margin-bottom: 38px; }
.process-list { display: grid; grid-template-columns: repeat(3, 1fr); gap: 34px; }
.process-step h4 { margin: 0 0 9px; color: #2b4564; font-size: 18px; font-weight: 600; }
.process-step p { margin: 0; color: #77879a; font-size: 14px; line-height: 1.8; }
.value-section { display: flex; align-items: center; justify-content: space-between; gap: 80px; padding: 75px max(24px, calc((100vw - 1200px) / 2)); }
.value-copy { max-width: 420px; }
.value-copy > p:last-child { margin: 18px 0 0; color: #76869a; font-size: 15px; line-height: 1.9; }
.value-list { display: flex; min-width: 490px; border-top: 1px solid #e2eaf3; border-bottom: 1px solid #e2eaf3; }
.value-item { flex: 1; padding: 22px 20px; border-right: 1px solid #e2eaf3; }
.value-item:first-child { padding-left: 0; }
.value-item:last-child { border-right: 0; }
.value-item strong { display: block; color: #2e73e8; font-size: 19px; font-weight: 600; }
.value-item span { display: block; margin-top: 9px; color: #7d8c9e; font-size: 12px; line-height: 1.6; }
@media (max-width: 900px) { .knowledge-hero { gap: 35px; } .hero-content h2 { font-size: 34px; } .knowledge-features { grid-template-columns: repeat(2, 1fr); } .value-section { gap: 40px; } .value-list { min-width: 0; } }
@media (max-width: 650px) { .knowledge-hero { display: block; padding: 58px 24px; } .hero-content h2 { font-size: 29px; } .hero-description { font-size: 14px; } .hero-panel { width: auto; margin-top: 36px; } .overview-section, .process-section { padding: 58px 20px; } .section-heading { margin-bottom: 32px; } .section-heading h3, .value-copy h3 { font-size: 25px; } .knowledge-features, .process-list { grid-template-columns: 1fr; gap: 14px; } .knowledge-feature { min-height: 0; } .process-step { padding: 18px 0; } .value-section { display: block; padding: 58px 24px; } .value-list { display: block; min-width: 0; margin-top: 30px; } .value-item, .value-item:first-child { padding: 18px 0; border-right: 0; border-bottom: 1px solid #e2eaf3; } .value-item:last-child { border-bottom: 0; } }
</style>
